import { render, staticRenderFns } from "./t-form-list-trigger.vue?vue&type=template&id=b3fcfb2e&"
import script from "./t-form-list-trigger.vue?vue&type=script&lang=js&"
export * from "./t-form-list-trigger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports